module.exports = __webpack_public_path__ + "media/images/emails/img-footer-agora-0091868474c9edd18d993478c355208e.jpg";